import React, { FC } from 'react'
import { Container, Typography } from '@cleartrip/ct-design-components'
import BenefitsIcon from '@/assets/icons/BenefitsIcon'
import { formatCurrency } from '@/utils/general/browserHelper'

interface PriceBenefitsInfoProps {
    price: number
}

const PriceBenefitsInfo: FC<PriceBenefitsInfoProps> = ({price}) => {
    return (
        <Container 
            className="flex pl-4" 
            css={{
                backgroundColor: "#ECF8F4", 
                paddingBottom: "8px", 
                paddingTop: "22px",
                marginTop: "-12px",
                flexGrow: 1,
                borderBottomLeftRadius: "16px",
                borderBottomRightRadius: "16px"
        }}>
            <BenefitsIcon />
            <Typography variant="B3" color="success" className="pl-1">
                Additional benefits worth {formatCurrency(price)}
            </Typography>
        </Container>
    )
}

export default PriceBenefitsInfo
